// extracted by mini-css-extract-plugin
module.exports = {"input":"css_input__2uMPk"};